import { useState } from "react";
import { Container, Row, Col, Modal } from "react-bootstrap";
import ProjectCards from "./ProjectCards";
import huemind from "../../Assets/Projects/huemind.png";
import minddrift from "../../Assets/Projects/minddrift.png";
import resybot from "../../Assets/Projects/resybot.png";
import film from "../../Assets/Projects/film.png";
import landscape from "../../Assets/Projects/landscape.svg";
import ContactForm from "../ContactForm";
import { useScrollAnimation } from "../../hooks/useScrollAnimation";
import SectionTitle from "../SectionTitle";

function Projects() {
  const [showModal, setShowModal] = useState(false);
  useScrollAnimation();

  return (
    <Container fluid className="project-section">
      <Container>
        <SectionTitle number={2} title="Projects" />

        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>

          <Col md={4} className="project-card animate-on-scroll">
            <ProjectCards
              showVideo={false}
              imgPath={landscape}
              title="AI Landscape"
              description={`Interactive bubble chart mapping 41 AI companies across 7 categories, plotted by total capital raised vs. valuation/funding multiple. Shows where the market is betting and which companies are creating the most value per dollar raised. Built on public funding data through Q1 2026.`}
              viewRoute="/landscape"
            />
          </Col>

          <Col md={4} className="project-card animate-on-scroll delay-1">
            <ProjectCards
              showVideo={false}
              imgPath={resybot}
              title="Resy Bot"
              description={`Automated reservation hunter that monitors impossible-to-get NYC tables and claims them the instant they open. Monitors listings 24/7 and books in under 60 seconds of availability. Built with Playwright + Flask.`}
              demoLink="https://resybot.site"
              onContact={() => setShowModal(true)}
              contactText="CONTACT ME"
            />
          </Col>

          <Col md={4} className="project-card animate-on-scroll delay-2">
            <ProjectCards
              showVideo={false}
              imgPath={huemind}
              title="HueMind"
              description={`Drop any URL and get a full WCAG audit in under 3 seconds. Checks contrast ratios across the entire palette and suggests fixes grounded in color theory. Built with Next.js, Tailwind, and Framer Motion.`}
              ghLink="https://github.com/blu-99/huemind"
              demoLink="https://huemind.vercel.app"
            />
          </Col>

          <Col md={4} className="project-card animate-on-scroll delay-3">
            <ProjectCards
              showVideo={false}
              imgPath={minddrift}
              title="MindDrift"
              description={`Chrome extension that catches you the moment you drift. Detects when you switch away from your work tab and surfaces a nudge to refocus. No sign-up, no data sent, runs entirely in your browser.`}
              ghLink="https://github.com/blu-99/minddrift"
              demoLink="https://github.com/blu-99/minddrift"
            />
          </Col>

          <Col md={4} className="project-card animate-on-scroll delay-1">
            <ProjectCards
              showVideo={false}
              imgPath={film}
              title="Film Script Database"
              description={`Searchable library of 400+ film scripts with full-text search, filtering by writer and decade, and inline page previews. Built for writers and film students tired of hunting Google for PDFs. Powered by Supabase + Next.js.`}
              demoLink="https://fruitstand.site"
              onContact={() => setShowModal(true)}
              contactText="CONTACT ME"
            />
          </Col>

        </Row>

        <Modal
          show={showModal}
          onHide={() => setShowModal(false)}
          centered
          size="lg"
        >
          <Modal.Header closeButton>
            <Modal.Title>Contact Me</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <ContactForm />
          </Modal.Body>
        </Modal>

      </Container>
    </Container>
  );
}

export default Projects;
